export default __webpack_public_path__ + "static/media/math-background-9.4ab03471.png";